import { useNationality } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useNationality";
import { useQuery as useFetchIncomeRanges } from "@faire/web-api--source/endpoints/www/api/user/income-ranges/get-hooks";
import { IDisplayableMoneyRange } from "@faire/web-api--source/indigofair/data/IDisplayableMoneyRange";
import { ISignUpRequest } from "@faire/web-api--source/indigofair/data/ISignUpRequest";
import keyBy from "lodash/keyBy";
import omit from "lodash/omit";
import { useCallback, useMemo } from "react";

export const useIncomeRanges = (formCountry?: string) => {
  const { retailerCountry } = useNationality();

  const country = useMemo(
    () => formCountry ?? retailerCountry,
    [formCountry, retailerCountry]
  );

  const { data: incomeRangesData, isLoading: isLoadingIncomeRanges } =
    useFetchIncomeRanges({ country: country });

  const incomeRanges = useMemo(
    () => incomeRangesData?.income_money_ranges ?? [],
    [incomeRangesData]
  );

  const incomeRangesOptions = useMemo(() => {
    return incomeRanges.map((incomeRange: IDisplayableMoneyRange) => {
      return {
        label: incomeRange.display_text ?? "",
        value: incomeRange.display_text ?? "",
        key: incomeRange.annual_sales_range_option,
      };
    });
  }, [incomeRanges]);

  const incomeRangeByDisplayText = useCallback(
    (incomeRangeToFind: ISignUpRequest.IAnnualSales) => {
      return incomeRanges.find((incomeRange: IDisplayableMoneyRange) => {
        if (
          incomeRangeToFind.max_amount?.amount_cents ===
            incomeRange.max_amount?.amount_cents &&
          incomeRangeToFind.min_amount?.amount_cents ===
            incomeRange.min_amount?.amount_cents
        ) {
          return true;
        }
        return false;
      });
    },
    [incomeRanges]
  );

  const incomeRangesByDisplayText = useMemo(() => {
    return keyBy(incomeRanges, "display_text");
  }, [incomeRanges]);

  const incomeRangeForKey = useCallback(
    (displayText: string): Partial<ISignUpRequest.IAnnualSales> => {
      return omit(incomeRangesByDisplayText[displayText], "display_text");
    },
    [incomeRangesByDisplayText]
  );

  return {
    isLoadingIncomeRanges,
    incomeRangesOptions,
    incomeRangeForKey,
    incomeRangeByDisplayText,
    incomeMoneyRanges: incomeRanges,
  };
};
